import { render, staticRenderFns } from "./ServerInfo.vue?vue&type=template&id=3c27236c&scoped=true&"
import script from "./ServerInfo.vue?vue&type=script&lang=js&"
export * from "./ServerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ServerInfo.vue?vue&type=style&index=0&id=3c27236c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27236c",
  null
  
)

export default component.exports